import { Alert, Button, Card, Checkbox, Form, Input, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CountryBean } from '../../../api/api'
import { formDataLoader, FormDataType } from '../../../util/FormDataLoader'
import mediaAgencyApi from './MediaAgencyApi'

const FormItem = Form.Item
const Option = Select.Option

interface Props { }

const formInfoItems: FormDataType[] = [
    FormDataType.Countries,
    FormDataType.MediaAgencies
]

const MediaAgencyEdit: React.FC<Props> = () => {

    const [info, setInfo] = useState({
        countries: []
    })

    const [form] = useForm()
    const [error, setError] = useState()
    const { id } = useParams<{ id: string }>()
    const navigateTo = useNavigate()

    const loadData = async () => {
        try {
            const response = await mediaAgencyApi.view(id)
            form.setFieldsValue(response.data)

            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await mediaAgencyApi.edit(id, values)
            navigateTo('/media-agency')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
    >
        {error ? <Alert message={error} type="error" /> : null}
        <Card title="Media Agency" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
                required
            >
                <Checkbox />
            </FormItem>
            <FormItem
                required
                name="countryId"
                label="Country"
            >
                <Select
                    showSearch
                    allowClear
                    optionFilterProp="title"
                    placeholder="Select country"
                >
                    {info.countries.map((item: CountryBean) =>
                        <Option title={item.name} key={item.code} value={item.code}>{item.name}</Option>
                    )}
                </Select>
            </FormItem>
            <FormItem
                name="description"
                label="Description"
            >
                <Input placeholder="Description" />
            </FormItem>
            <FormItem
                name="domain"
                label="Domain"
            >
                <Input placeholder="Domain" />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Save</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/media-agency')}>Cancel</Button>
        </div>
    </Form>
}

export default MediaAgencyEdit


// WEBPACK FOOTER //
// ./src/component/app/mediaAgency/MediaAgencyEdit.tsx